/**
 * This forces the browser to redraw.
 *
 * Explanation:
 * https://css-tricks.com/restart-css-animation/#aa-update-another-javascript-method-to-restart-a-css-animation
 */
export function forceBrowserRedraw() {
  void document.body.offsetWidth;
}
